export class KPIDataDefinitionChoice {
  choiceKey: number;

  value?: string;

  description?: string;

  constructor() {
    this.choiceKey = 0;
  }

  clone(): KPIDataDefinitionChoice {
    const output = new KPIDataDefinitionChoice();
    output.choiceKey = this.choiceKey;
    output.value = this.value;
    output.description = this.description;

    return output;
  }

  isEqual(item: KPIDataDefinitionChoice): boolean {
    return item.choiceKey === this.choiceKey && item.value === this.value && item.description === this.description;
  }
}

export default class KPIDataDefinition {
  kpiDefinitionRevisionId: number;

  type: number;

  decimalCount: number;

  //the default of the revision that governed the value, shown beside the answer
  defValue?: string;

  choices: KPIDataDefinitionChoice[];

  constructor() {
    this.kpiDefinitionRevisionId = 0;
    this.type = 0;
    this.decimalCount = 0;
    this.choices = [];
  }

  clone(): KPIDataDefinition {
    const output = new KPIDataDefinition();
    output.kpiDefinitionRevisionId = this.kpiDefinitionRevisionId;
    output.type = this.type;
    output.decimalCount = this.decimalCount;
    output.defValue = this.defValue;
    output.choices = this.choices.map((choice) => choice.clone());

    return output;
  }

  isEqual(item: KPIDataDefinition): boolean {
    if (
      item.kpiDefinitionRevisionId !== this.kpiDefinitionRevisionId ||
      item.type !== this.type ||
      item.decimalCount !== this.decimalCount ||
      item.defValue !== this.defValue ||
      item.choices.length !== this.choices.length
    ) {
      return false;
    }

    return item.choices.every((choice, index) => choice.isEqual(this.choices[index]));
  }
}
